export const locales = ['he', 'en', 'ar', 'ru'];
export const defaultLocale = 'he';
